import React from 'react';

import { Box, Button, Typography } from '@mui/material';

import DepartureActionPills from './DepartureActionPills';
import RMStatusChips from './RMStatusChips';
import { TourRow, money } from './logic';
import type { CostBasis, OfferPriority } from './types';

export default function RMReviewTable({
  tours,
  priorities,
  basis,
  open,
  today,
}: {
  tours: Array<TourRow>;
  priorities: Array<OfferPriority>;
  basis: CostBasis;
  open: (id: string) => void;
  today?: string;
}) {
  const columns = ['Tour', 'Departure Actions', '$ at risk', 'Draft score'];
  const grid = { display: 'grid', gridTemplateColumns: { xs: '1fr', md: '2fr 2fr 1fr 0.6fr' }, gap: 1, p: 1.5 };
  return (
    <Box role="table" aria-label="RM review queue" sx={{ minWidth: 0 }}>
      <Box role="row" sx={{ ...grid, display: { xs: 'none', md: 'grid' }, bgcolor: 'action.hover' }}>
        {columns.map((c) => (
          <Typography role="columnheader" variant="caption" fontWeight={700} key={c}>
            {c}
          </Typography>
        ))}
      </Box>
      {tours.map((t) => {
        const priority = priorities.find((p) => p.opp_id === t.id);
        return (
          <Box
            role="row"
            key={t.id}
            sx={{
              ...grid,
              borderBottom: '1px solid',
              borderColor: 'divider',
              alignItems: 'center',
              '& > *': { minWidth: 0, overflowWrap: 'anywhere' },
            }}
          >
            <Box role="cell">
              <Button onClick={() => open(t.id)} sx={{ p: 0, textAlign: 'left', justifyContent: 'flex-start' }}>
                {t.name}
              </Button>
              <Typography variant="caption" display="block">
                {t.rows.length} {t.rows.length === 1 ? 'departure' : 'departures'}
              </Typography>
            </Box>
            <Box role="cell">
              <DepartureActionPills rows={t.rows} basis={basis} today={today} />
              <RMStatusChips rows={t.rows} />
            </Box>
            <Box role="cell">
              {priority?.loss_exposure > 0 && (
                <Typography variant="caption">
                  {money(priority.loss_exposure)}
                  <Box component="span" sx={{ display: { xs: 'inline', md: 'none' } }}>
                    {' '}
                    at risk
                  </Box>
                </Typography>
              )}
            </Box>
            <Box role="cell">
              <Typography variant="caption" sx={{ display: { md: 'none' } }}>
                Draft score:{' '}
              </Typography>
              {priority?.draft_score?.toFixed(1) ?? '—'}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
